import { useState, useEffect } from "react";
import styles from "./styles.module.css";
import Grid from "@mui/material/Grid";
import Button from "@mui/material/Button";
import IconButton from "@mui/material/IconButton";
import Tooltip from "@mui/material/Tooltip";
import { useMediaQuery } from "@mui/material";
import LazyLoader from "../../LazyLoader";
import Pagination from "../../Pagination";

const CardViewv2 = ({ columns, data, hasBotoes, paginationConfig }) => {
  const isServerSide =
    paginationConfig != null &&
    typeof paginationConfig.onServerPageChange === "function";
  const [visibleItems, setVisibleItems] = useState([]);
  const [loadedChunks, setLoadedChunks] = useState(0);
  const CHUNK_SIZE = 10;
  const minDesktop = useMediaQuery("(max-width: 951px)");

  useEffect(() => {
    if (isServerSide) return;
    setLoadedChunks(0);
    setVisibleItems([]);
  }, [data, isServerSide]);

  useEffect(() => {
    if (isServerSide) {
      setVisibleItems(Array.isArray(data) ? data : []);
      return;
    }
    if (data.length > 0) {
      const endIndex = Math.min((loadedChunks + 1) * CHUNK_SIZE, data.length);
      const newItems = data.slice(0, endIndex);
      setVisibleItems(newItems);
    } else {
      setVisibleItems([]);
    }
  }, [data, loadedChunks, isServerSide]);

  const loadMoreItems = () => {
    if (visibleItems.length < data.length) {
      setLoadedChunks((prev) => prev + 1);
    }
  };

  return (
    <div className={styles.gridContainer}>
      <Grid container spacing={2} justifyContent={`${minDesktop ? "center" : "space-between"}`}>
        {visibleItems.map((item, index) => (
          <Grid key={index} item sx={4}>
            <LazyLoader
              onVisible={
                isServerSide || index !== visibleItems.length - 1
                  ? null
                  : loadMoreItems
              }
            >
              <div
                className={styles.card}
                style={{
                  height: `${columns.length * 28 + (hasBotoes ? (item.btn?.length > 1 ? 52 : 44) : 0)}px`,
                }}
              >
                <div className={styles.header}></div>
                {columns.map((column, i) => (
                  <div key={i}>
                    <span className={styles.itemCard}>
                      {column.label}:{" "}
                      {typeof item[column.key] === "function"
                        ? item[column.key]()
                        : item[column.key]}
                    </span>
                    <br />
                  </div>
                ))}
                {hasBotoes && (
                  <div className={styles.containerBtn}>
                    {item.btn.length === 1 ? (
                      <Button
                        className={styles.btnDropdown}
                        fullWidth
                        onClick={() => item?.btn[0]?.onClick()}
                        disabled={item?.btn[0]?.disabled}
                      >
                        {item?.btn[0]?.icon} {item?.btn[0]?.title}
                      </Button>
                    ) : (
                      <div className={styles.acoesIconesBarra}>
                        {item?.btn?.map((button, index) => (
                          <Tooltip key={index} title={button.title} arrow>
                            <span>
                              <IconButton
                                onClick={() => button.onClick()}
                                disabled={button.disabled}
                                size="small"
                                aria-label={button.title}
                                sx={{
                                  color:
                                    button.variant === "danger"
                                      ? "#ffcdd2"
                                      : "#fff",
                                }}
                              >
                                {button?.icon}
                              </IconButton>
                            </span>
                          </Tooltip>
                        ))}
                      </div>
                    )}
                  </div>
                )}
              </div>
            </LazyLoader>
          </Grid>
        ))}
      </Grid>
      {isServerSide && (
        <Pagination
          data={data}
          filteredData={visibleItems}
          setFilteredData={() => {}}
          {...paginationConfig}
        />
      )}
    </div>
  );
};

export default CardViewv2;